<template>
  <div class="mb64">
    <div class="lock">
      <!--导航-->
      <nav class="customNav">
          <img src="../assets/imgs/image_logo.jpg" alt="" width="150px">
        <ul class="customNav_con">
          <span class="span">
         <div>
              <a
              :class="curName === item.name ? 'activ' : ''"
              v-for="(item, index) in navBarList"
              :key="index"
              @click="onClickItemListener(item.name)"
            >
              {{ item.title }}
            </a>
         </div>
             <li
              id="customNavli"
              style="width: 120px"
               @mouseenter="showProduct()" @mouseleave = hideProduct()
            >
              <ul
               v-show="product"
                class="customNav-menu"
                id="customNav-menu"
              >
              </ul>
            </li>
            
            <a @mouseenter="showDownload()" @mouseleave = hideDownload()>
              <a>
                {{ supportAndDownload.title }}
              </a>
              <ul class="showDownload" v-show="downVideo">
                <li class="showDownloadLi"
                  v-for="(sadItem, sadIndex) in supportAndDownload.dropdown"
                  :key="sadIndex"
                >
                  <p
                    @click="onClickItemListener(sadItem.name)"
                  >
                    {{ sadItem.title }}
                  </p>
                </li>
              </ul>
            </a>
          </span>
        </ul>
        <!--左边栏-->
        <div class="customNav-right" style="height: 100%;display: flex; flex-direction: row;" id="lang_wen">
          <div v-if="!userInfoData.headerUrl"
               style="height: 100%;display: flex;justify-content: center;align-items: center;cursor: pointer;color:rgb(221, 221, 221);"  @click="onHeaderClick">
              <div style="background-color:#2566FF;padding:15px 30px;margin-left:20px;">Log in</div>
          </div>
          <el-dropdown v-if="userInfoData.headerUrl" trigger="click" placement="top-start">
         <div style="height: 100%;display: flex;justify-content: center;align-items: center;">
              <img
                alt="Brand"
                :src="userInfoData.headerUrl"
                class="img-responsive imgperson"/>
                <span style="padding-left:10px;color:rgb(201, 201, 201);">{{ userInfoData.nickname}}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <div class="flex-wrp flex-column">
                  <div class="flex-wrp flex-row" style="height: 40px;">
                    <el-image
                      v-if="userInfoData.headerUrl"
                      :src="userInfoData.headerUrl"
                      style="width: 40px; height: 40px; margin-right: 20px; border-radius: 20px; background-color: gray;"
                    ></el-image>
                  </div>
                </div>
              </el-dropdown-item>
              <a :href="userCenterUrl + '?token=' + this.$cookies.get('token')" target="_blank">
                <el-dropdown-item>
                  {{this.$al.login.personalCenter}}
                </el-dropdown-item>
              </a>
              <el-dropdown-item>
                <div
                  style="width: 100%; height: 100%; text-align: end;"
                  @click="logout"
                >
                  {{this.$al.login.LogOut}}
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="customNav_rightBtn" id="customNav_right">
            <img
              src="@/assets/imgs/image_menu.jpg"
              class="imgbtn"
              id="customNav_rightBtn"
            />
          </span>
        </div>
          <!--下拉内容-->
        <ul class="customNav_rightBtn_con" id="show2">
          <li
            :class="curName === item2.name ? 'activ' : ''"
            v-for="(item2, index2) in navBarList"
            :key="index2"
          >
            <a @click="onClickItemListener(item2.name)"> {{ item2.title }} </a>
          </li>
          <li class="li-cyStyle cyStyle">
              <a id="customNav-btn2">
              {{ supportAndDownload.title }} <span class="caret"></span
            ></a>
          </li>
          <ul class="customNav-menu2" id="customNav-menu2">
            <li
              v-for="(sad2Item, sad2Index) in supportAndDownload.dropdown"
              :key="sad2Index"
            >
              <a @click="onClickItemListener(sad2Item.name)">
                {{ sad2Item.title }}
              </a>
            </li>
          </ul>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: ['userInfo'],
  data() {
    return {
      userInfoData: this.userInfo,
      websiteBaseUrl: window.SITE_CONFIG.websiteBaseUrl,
      userCenterUrl:
        window.SITE_CONFIG.websiteBaseUrl +
        '/#/front/Personal/PersonalInformation',
      product:false,
      downVideo:false,
      company: "亦心科技",
      curName: "PhotoSir",
      navBarList: [
        {
          title: "PhotoSir",
          name: "PhotoSir",
        },
        {
          title: "AI FlashPaint",
          name: "AiFlashPaint",
        },
        {
          title: "Store",
          name: "Buy",
        },
          {
          title: "News",
          name: "CompanyNews",
        },
      ],
      supportAndDownload: {
        title: "Support",
        name: "SupportAndDownload",
        dropdown: [
          {
            title: "Download",
            name: "Download",
          },
          {
            title: "Tutorial",
            name: "VideoTutorial",
          }
        ],
      },
    };
  },
  watch: {
    userInfo: function (userInfo) {
      this.userInfoData = userInfo;
    }
  },
  methods: {
    goTo(){
      this.$router.push('/PhotoContest')
    },
    showProduct(){
      this.product = true
    },
    hideProduct(){
      this.product = false
    },
    showDownload(){
      this.downVideo = true
    },
    hideDownload(){
      this.downVideo = false

    },
    /**
     * 导航条中子组件(nav-item)点击事件
     * @param name 被点击条目标题
     */
    onClickItemListener(name) {
      let that = this;
      that.curName = name;
      that.$router.push({ path: name });
    },
    onHeaderClick () {
      this.$emit('headerClick')
    },
    logout () {
      this.$router.push({ query: {} });
      this.$confirm(this.$al.login.logoutTip, this.$al.login.tip, {
        confirmButtonText: this.$al.login.confirm,
        cancelButtonText: this.$al.login.cancel,
        type: 'warning'
      })
        .then(() => {
          this.isLogin = false
          this.userInfoData = {
            headerUrl: '',
            nickname: '',
            isSVip: false,
            grade: ''
          }
          this.$router.go(0)
          this.$cookies.set('token', '') // 清除本地token
          window.localStorage.clear() // 清除本地所有缓存信息 (！！！由于要保留抠章图片信息SealInfo，所以不能clear全部清空)
          // localStorage.removeItem('isLogin');
          // localStorage.removeItem("UserInfo");
        })
    },
  },
  created() {
    this.curName = this.$route.name;
    $("body").bind("click", function (event) {
      // IE支持 event.srcElement ， FF支持 event.target
      var evt = event.srcElement ? event.srcElement : event.target;
      if (evt.id === "customNav-btn" || evt.id === "customNav-btn") {
        if ($("#customNav-menu").is(":hidden")) {
          $("#customNav-menu").show();
        } else {
          $("#customNav-menu").hide();
        }
      } else if (evt.id === "customNav_rightBtn" || evt.id === "customNav_rightBtn") {
        // 如果是元素本身，则返回
        if ($("#show2").is(":hidden")) {
          $("#show2").show();
        } else {
          $("#show2").hide();
        }
      } else {
        $("#customNav-menu").hide();
        $("#show2").hide(); // 如不是则隐藏元素
      }
    });
  },
}
</script>

<style scoped>
  .flex-wrp {
    display: flex;
    justify-content: space-between;
  }

  .flex-column {
    flex-direction: column;
  }

  .flex-row {
    flex-direction: row;
  }


  .showDownload {
    position: absolute;
    width: 180px;
    top: 50px;
    padding: 0 20px 20px 20px;
    background-color: #202124;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0px 0px 4px 4px;
  }

  .showDownloadLi {
    background: #000000;
    cursor: pointer;
    font-size: 12px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    height: 50px;
    line-height: 20px;
    margin-top: 10px;
    letter-spacing: 2px;
    width: 140px !important;
    border-radius: 4px 4px 4px 4px;
  }

  .mb64 {
    margin-bottom: 50px;
  }

  .lock {
    position: fixed;
    z-index: 888;
    width: 100%;
    top: 0;
    background-color: #181a1e;
  }

  .select {
    background-color: #181a1e;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    border: none;
    display: block;
    outline: none;
  }

  .dropdown-menu {
    background-color: #181a1e;
    border: 0px;
  }

  .dropdown-menu li a:hover {
    background: rgba(255, 255, 255, 0.13);
    color: #fff;
    font-size: 15px;
    font-weight: 500;
  }

  .dropdown-menu {
    padding: 0 0;
  }

  .imgperson {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }

  .imgmenu {
    width: 22px;
    float: left;
    padding-top: 21px;
    margin-left: 15px;
  }

  /*customNav*/
  .customNav {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    height: 50px;
    display: flex;
  }

  #customNav {
    position: relative;
  }

  .customNav-brand {
    position: absolute;
    left: 100px;
    top: 5px;
  }

  .navbar_logotext {
    font-size: 24px;
    color: #ffffff;
    margin-left: 10px;
    float: left;
    margin-top: 4px;
  }

  .logoImg {
    width: 40px;
    float: left;
  }

  .customNav_con {
    width: 980px;
    margin: 0 auto;
  }

  .customNav_con a {
    float: left;
    list-style: none;
    width: 120px;
    font-size: 14px;
    font-family: Source Han Sans CN-Light, Source Han Sans CN;
    font-weight: 300;
    text-align: center;
    line-height: 50px;
  }

  .customNav_con li {
    float: left;
    font-size: 12px;
    list-style: none;
    width: 90px;
    text-align: center;
    line-height: 50px;
  }


  .customNav_con a {
    color: rgb(221, 221, 221);
    text-decoration: none;
    display: block;
    cursor: pointer;
  }

  .activ {
    /* background: rgba(255, 255, 255, 0.13); */
    color: #fff !important;
    font-weight: 900 !important;
  }

  .customNav_con span a:hover {
    color: #61aeff;
    text-decoration: none;
  }

  /* .customNav_con span a.activ:hover {
    background: rgba(255, 255, 255, 0.13);
    color: #fff;
  } */

  .customNav_con span .customNavli.activ:hover,
  .customNav_con span .customNavli.activ a:hover {
    background: rgba(255, 255, 255, 0.13);
    width: 120px;
    color: #fff;
  }

  .customNav_con a:focus {
    background: rgba(255, 255, 255, 0.13);
    color: #fff;
    text-decoration: none;
  }

  .customNav_con .cyStyle {
    background: url(../assets/imgs/image_header_gamebg.jpg) no-repeat center;
    background-size: 90px 36px;
    width: 120px;
  }

  .customNav_con .cyStyle:hover {
    background: url(../assets/imgs/image_header_gamebg.jpg) no-repeat center;
    background-size: 90px 36px;
  }

  .customNav_con .cyStyle a:hover {
    background: transparent;
  }

  .customNav_con .cyStyle.activ {
    background: url(../assets/imgs/image_header_gamebg.jpg) no-repeat center;
  }

  .customNav-menu {
    background: #202124;
    color: #fff;
    overflow: hidden;
    /* display: none; */
    z-index: 5;
    position: absolute;
    top: 50px;
    margin-left: -100px;
  }

  .customNav-menu .dis {
    margin: 20px 20px 20px 0px;
    display: flex;
    justify-content: space-around;
    color: rgb(181, 181, 181);
    cursor: pointer;
  }

  .customNav-menu .dis li {
    background-color: #000;
    width: 200px;
    height: 250px;
    margin-left: 20px;
    border-radius: 4px;
  }

  .customNav-menu .dis .title {
    font-size: 14px;
    text-align: left;
    color: #fff;
    padding-left: 20px;
  }

  .customNav-menu .dis .describe {
    font-size: 12px;
    text-align: left;
    color: #9E9E9E;
    padding-left: 20px;
  }

  .customNav-menu a,
  .customNav-menu li {
    margin-right: 0;
  }

  .customNav-menu2 {
    background: #181a1e;
    color: #fff;
    overflow: hidden;
    /* display: none; */
  }

  .customNav-menu li {
    line-height: 42px;
    float: none;
  }

  .customNav-right {
    position: absolute;
    right: 0%;
  }

  .customNav_rightBtn {
    float: left;
    color: #fff;
    display: none;
    line-height: 50px;
    margin-left: 20px;
    cursor: pointer;
    height: 100%;
    width: 30px;
    text-align: center;
  }

  .customNav_rightBtn_con {
    width: 100%;
    background: #181a1e;
    height: auto;
    display: none;
    position: absolute;
    top: 50px;
    border-top: 1px solid #fff;
    z-index: 5;
  }

  .customNav_rightBtn_con li {
    height: 36px;
    line-height: 36px;
    list-style: none;
    cursor: pointer;
  }

  .customNav_rightBtn_con li:hover {
    background: rgba(255, 255, 255, 0.13);
  }

  .customNav_rightBtn_con li a {
    color: #fff;
    padding-left: 20px;
    display: block;
  }

  #customNav-menu2 li {
    padding-left: 20px;
  }

  @media (max-width: 1450px) {
    .logoImg {
      width: 44px;
    }

    .navbar_logotext {
      font-size: 23px;
    }

    .customNav_con {
      width: 850px;
      margin: 0 auto;
    }
  }

  @media (max-width: 950px) {
    .customNav_con {
      display: none;
    }

    .customNav_rightBtn {
      display: block;
      cursor: pointer;
    }
  }

  @media (max-width: 1100px) {
    .logoImg {
      width: 43px;
    }

    .navbar_logotext {
      font-size: 22px;
    }
  }

  @media (max-width: 992px) {
    .logoImg {
      width: 42px;
    }

    .navbar_logotext {
      font-size: 21px;

    }
  }

  @media (max-width: 768px) {
    .logoImg {
      width: 40px;
    }

    .navbar_logotext {
      font-size: 16px;
      margin-top: 9px;
      float: left;
    }

    .imgmenu {
      width: 18px;
      float: left;
      padding-top: 23px;
      margin-left: 3px;
    }

    .imgperson {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .imgbtn {
      width: 17px;
    }

    .customNav-right {
      right: 3%;
    }

    .select {
      background-color: #181a1e;
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      border: none;
      display: block;
      outline: none;
      /*将默认的select选择框样式清除*/
      border-color: transparent;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }

    select::-ms-expand {
      display: none;
    }

    .customNav-brand {
      position: absolute;
      top: 13px;
      left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue